class PaginationPerPage {

    constructor() {   

        return {
            restrict: 'E',
            templateUrl: "components/pagination-per-page.html",
            scope: {
                entityType: "@",
                itemsPerPage: "="
            },
            link: ($scope, $el, $attr) => {

                let previouslySelected = localStorage.getItem($scope.entityType + "ItemsPerPage");
                if(!!previouslySelected) {
                    $scope.itemsPerPage = parseInt(previouslySelected);
                }
                else {
                    localStorage.setItem($scope.entityType + "ItemsPerPage", 25);
                }

                $scope.$watch('itemsPerPage', (newVal, oldVal) => {
                    if(!!oldVal && !!newVal && (oldVal != newVal)) {
                        localStorage.setItem($scope.entityType + "ItemsPerPage", newVal);
                    }
                });

            }
        };

    }

}

angular.module('cpm')
    .directive('paginationPerPage', () => {
        'use strict';
        return new PaginationPerPage();
    });